import _ from 'lodash'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

/**
 * 创意列表
 * @param {{type: string}} params 创意类型(1：交互素材;2：非交互素材)
 */
export function fetchCreationTag(params) {
  return request({
    url: `${v2Host}/demand/creation-tag/list`,
    method: 'get',
    params: params
  })
}

/**
 * 删除创意标签
 * @param {*} params
 */
export function deleteCreationTag(id, params) {
  return request({
    url: `${v2Host}/demand/creation-tag/del?id=${id}`,
    method: 'get',
    params: params
  })
}

/**
 * 添加创意标签
 * @param {*} data
 */
export function addCreationTag(data) {
  return request({
    url: `${v2Host}/demand/creation-tag/create`,
    method: 'post',
    data: data
  })
}

/**
 * 创意详情
 * @param {*} params
 */
export function fetchCreationDetail(params) {
  return request({
    url: `${v2Host}/demand/creation/info`,
    method: 'get',
    params: params
  })
}

/**
 * 根据创意名称或者创意id获取特征标签
 * @param {*} data
 */
export function fetchMaterialTag(data) {
  return request({
    url: `${v2Host}/demand/creation/material-tag`,
    method: 'post',
    data: data
  })
}

/**
 * 通过keyword获取创意特征列表
 * @param {*} params
 */
export function fetchCreationTagList(params) {
  return request({
    url: `${v2Host}/demand/creation/tag-list`,
    method: 'get',
    params
  })
}

/**
 * 打包下载创意
 * @param {*} params
 */
export function packageDownloadCreation(params) {
  return request({
    url: `${v2Host}/demand/creation/download`,
    method: 'get',
    params: params
  })
}

/**
 * 创意列表
 * @param {*} params
 */
export function fetchCreationList(params) {
  return request({
    url: `${v2Host}/demand/creation/list`,
    method: 'get',
    params: cookRequestParams(params)
  })
}

export function getCreationSizeList(params) {
  return request({
    url: `${v2Host}/demand/creation-size/list`,
    method: 'get',
    params: params
  })
}

/**
 * 打包
 * http://playable.dev.com:8067/?doc=creative/custom_dist.go
 * @param {*} data
 */
export function packageCreation(data) {
  return request({
    url: `${v2Host}/dmaker/custom-dist/create`,
    method: 'post',
    data: data
  })
}

/**
 * 发布
 * http://playable.dev.com:8067/?doc=creative/custom_dist.go
 * @param {*} data
 */
export function publishCreation(data) {
  return request({
    url: `${v2Host}/dmaker/custom-dist/publish`,
    method: 'post',
    data: data
  })
}

export function updateMaterialTag(data) {
  const id = data.id
  data = _.omit(data, ['id'])
  return request({
    url: `${v2Host}/demand/creation/material-tag?id=${id}`,
    method: 'post',
    data: data
  })
}
